import { render, staticRenderFns } from "./SitesGroupsConfigurations.vue?vue&type=template&id=f48fbe94&scoped=true"
import script from "./SitesGroupsConfigurations.vue?vue&type=script&lang=js"
export * from "./SitesGroupsConfigurations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48fbe94",
  null
  
)

export default component.exports